import React from 'react'

const MentalHeathCaseStudies = () => {
    return (
        <section className="lg:py-28 lg:px-12 px-5  py-28 bg-bgDefault text-white ">
            <div className='container xl:mx-auto xl:max-w-screen-xl'>
                <div className='grid grid-cols-12'>
                    <div className='col-span-6'>
                        <h2 className="text-heading-4 lg:text-[60px] lg:leading-[100%] font-dmsans font-bold tracking-[-0.06em] mb-8 ">
                            Empowering Mental Health Professionals
                        </h2>
                         <div className="flex flex-wrap gap-2 mt-2 mb-6">
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Java
                            </span>

                        </div>
                         <p className="text-[#9E9E9E] mb-6 text-base md:text-body font-roboto ">
                              We partnered with a leading psychiatric clinic to revolutionize their mental healthcare delivery through
                              comprehensive digital transformation. Our secure, HIPAA-compliant platform successfully streamlined patient
                              management, session documentation, prescription workflows, and teleconsultation services, resulting in 45%
                              faster appointment scheduling, 60% improvement in clinical documentation accuracy, and 50% increase in
                              patient engagement. The solution now serves thousands of patients monthly with 99.9% uptime, establishing
                              new standards for digital mental healthcare delivery.
                            </p>
                       
                    </div>
                    <div className='col-span-6'>
                      <img src='/case_studies/title-banner/mentor-app-title-banner.png' alt='Mental Health Platform'></img>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default MentalHeathCaseStudies